if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.variantSelects = this.querySelector('variant-radios');
        this.submitButton = this.querySelector('[type="submit"]');
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector('.quantity__rules-cart .loading-overlay').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart .loading-overlay').classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }
    }
  );
}

if (window.innerWidth <= 750) {
    const drawerHeight = document.querySelector('.new-product__info.close').offsetHeight;
    const headerHeight = document.querySelector('header').offsetHeight;

    const productImages = document.querySelectorAll('.new-product__mobile--image');
    productImages.forEach(img => {
      const availableHeight = window.innerHeight - 180 - headerHeight;
      img.style.height = availableHeight + 'px';
    });
    console.log(drawerHeight, headerHeight);
}

const productInfoOpener = document.querySelector('.new-product__mobile-open');
const infoContainer = document.querySelector('.new-product__info');
const ctaContainer = document.querySelector('.new-product__cta-buttons');
const sizeSelectorContainer = document.querySelector('.new-product__size-selector');
const sizeSelectorBtn = document.querySelector('#ProductSubmitButton-mobile');

let storeInitialData;

infoContainer.addEventListener("touchmove", function(e){

  const isClose = this.classList.contains("close") ? true : false;
  
  // e.preventDefault();

  const touchData = e.touches[0];

  const yPosition = touchData.clientY;
  const windowHeight = window.innerHeight;

  const topPercentage = (yPosition / windowHeight) * 100;

  if(!isClose && topPercentage > 50){
    return;
  }

  if(yPosition > storeInitialData.clientY) {
    if (topPercentage > 30) {
      this.classList.add("close");
      this.scrollTo(0, 0)
    } else {
      this.classList.remove("close");
    }
  } else {
    if (topPercentage > 70) {
      this.classList.add("close");
      this.scrollTo(0, 0)
    } else {
      this.classList.remove("close");
    }
  }
});

infoContainer.addEventListener("touchstart", function(e){
  const isClose = this.classList.contains("close") ? true : false;
  
  const touchData = e.touches[0];

  const yPosition = touchData.clientY;
  const windowHeight = window.innerHeight;

  const topPercentage = (yPosition / windowHeight) * 100;

  if (isClose || topPercentage < 30) {
    e.preventDefault();
  }

  storeInitialData = touchData;

});

ctaContainer.addEventListener("touchmove", function(e){
  e.preventDefault();
});

sizeSelectorBtn.addEventListener("click", function(e){
  sizeSelectorContainer.classList.remove("close");
});

sizeSelectorContainer.addEventListener("touchmove", function(e){
  e.preventDefault();

  const touchData = e.touches[0];

  const yPosition = touchData.clientY;
  const windowHeight = window.innerHeight;

  const topPercentage = (yPosition / windowHeight) * 100;

  if (topPercentage > 87) {
    this.classList.add("close");
  }

});

